/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Addon_ReaddInputs */



/**
* | output |
* | --- |
* | "Re-add" |
*
* @param {Partner_Manage_Addon_ReaddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_addon_readd = /** @type {((inputs?: Partner_Manage_Addon_ReaddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Addon_ReaddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erneut hinzufügen")
	return /** @type {LocalizedString} */ ("Re-add")
});